module.exports = __webpack_public_path__ + "img/poster1.59acf6b7.png";